import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BookOpen, Download, LogOut } from "lucide-react";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import { Navbar } from "@/components/Navbar";
import api from "@/lib/api";

export default function MyLibrary() {
  const { user, loading, logout } = useCustomerAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/account"); return; }
    api.get("/account/library").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-[#F1F4F3]">
      <Navbar />
      <div className="px-6 md:px-12 pt-28 pb-24">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-brand mb-2">Your account</p>
            <h1 className="font-display font-black uppercase tracking-tight text-4xl md:text-5xl text-[#0E1E2E]">My Library</h1>
            {user && <p className="text-[#556673] mt-2">{user.name || user.email}</p>}
          </div>
          <button data-testid="acct-logout" onClick={() => { logout(); navigate("/"); }}
            className="flex items-center gap-2 font-mono2 text-xs uppercase tracking-[0.15em] border border-black/15 px-4 py-2 hover:bg-[#0E1E2E] hover:text-white transition-colors">
            <LogOut size={14} /> Log out
          </button>
        </div>

        {items === null ? (
          <p className="text-[#556673] font-mono2 text-sm">Loading…</p>
        ) : items.length === 0 ? (
          <div data-testid="library-empty" className="border border-black/10 bg-white p-12 text-center">
            <BookOpen size={40} className="text-brand mx-auto mb-5" />
            <h2 className="font-display font-bold text-2xl text-[#0E1E2E] mb-2">No ebooks yet</h2>
            <p className="text-[#556673] mb-6">Purchases you make will show up here.</p>
            <Link to="/#ebooks" className="inline-block px-6 py-3 bg-brand text-[#06111C] font-display font-bold uppercase tracking-wide text-xs hover:bg-[#27B95B] transition-colors">
              Browse ebooks
            </Link>
          </div>
        ) : (
          <div data-testid="library-list" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((it, i) => (
              <div key={i} className="border border-black/10 bg-white p-6 flex items-center justify-between gap-4">
                <div>
                  <h3 className="font-display font-bold text-lg text-[#0E1E2E]">{it.title}</h3>
                  <p className="font-mono2 text-[11px] uppercase tracking-[0.15em] text-[#8797A3] mt-1">Purchased · {it.provider}</p>
                </div>
                <a href="#" className="shrink-0 inline-flex items-center gap-1.5 px-4 py-2 bg-brand text-[#06111C] font-display font-bold uppercase tracking-wide text-xs hover:bg-[#27B95B] transition-colors">
                  <Download size={13} /> Get
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
